// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"467f3eba","321":"3c55afcd","535":"8b98a69f","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};